import { render, staticRenderFns } from "./ShippingForm.vue?vue&type=template&id=1b0e5072&scoped=true&"
import script from "./ShippingForm.vue?vue&type=script&lang=js&"
export * from "./ShippingForm.vue?vue&type=script&lang=js&"
import style0 from "./ShippingForm.vue?vue&type=style&index=0&id=1b0e5072&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b0e5072",
  null
  
)

export default component.exports